function init (): Promise<void> {
  return Promise.resolve() // mock async interface
}

export default init
